import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor() { }
  captureScreenshot(): Promise<Blob> {
    return html2canvas(document.body).then(canvas => {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          resolve(blob);
        });
      });
    });
  }
}
